import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

type MarketingDonutChartProps = {
  data: DonutSegment[];
};

export function MarketingDonutChart({ data }: MarketingDonutChartProps) {
  return (
    <div className="mt-4 flex justify-center">
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={55}
            outerRadius={85}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            stroke="none"
            paddingAngle={3}
          >
            {data.map((entry, i) => (
              <Cell key={i} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
